"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

require("./styles.css");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Logo = _interopRequireDefault(require("../Logo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Button)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "rippleRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "debounceTimer", null);

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var _this$props = _this.props,
          attached = _this$props.attached,
          textAlign = _this$props.textAlign,
          _float = _this$props["float"];
      var propNames = ['fluid', 'disabled', 'outline', 'ripple', 'borderless', 'upperCase', 'capitalize', 'basic', 'icon'];
      var names = [Button.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropValue)(names, _this.props, ['color']);

      _common.customClassNames.addAttachedHorizontal(names, attached);

      _common.customClassNames.addTextAlign(names, textAlign);

      _common.customClassNames.addFloat(names, _float);

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props2 = _this.props,
          onClick = _this$props2.onClick,
          disabled = _this$props2.disabled;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showRipple", function (e) {
      var targetRipple = _this.rippleRef.current;

      if (targetRipple) {
        var rippler = document.createElement('span');
        targetRipple.appendChild(rippler);
        var size = targetRipple.offsetWidth;
        var pos = targetRipple.getBoundingClientRect();
        var x = e.pageX - pos.left - size / 2;
        var y = e.pageY - pos.top - size / 2;
        var style = "top: ".concat(y, "px;left: ").concat(x, "px;height: ").concat(size, "px;width: ").concat(size, "px;");
        rippler.setAttribute('style', style);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearDebounce", function () {
      if (_this.debounceTimer) {
        clearTimeout(_this.debounceTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "debounce", function (func, delay) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      _this.clearDebounce();

      _this.debounceTimer = setTimeout(function () {
        return func.apply.apply(func, [_assertThisInitialized(_this)].concat(args));
      }, delay);
    });

    _defineProperty(_assertThisInitialized(_this), "cleanUp", function () {
      var targetRipple = _this.rippleRef.current;

      if (targetRipple) {
        while (targetRipple.firstChild) {
          targetRipple.removeChild(targetRipple.firstChild);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseDown", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          ripple = _this$props3.ripple,
          onMouseDown = _this$props3.onMouseDown;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (ripple) {
        _this.showRipple(e);
      }

      if (onMouseDown) {
        onMouseDown(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseUp", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          ripple = _this$props4.ripple,
          onMouseUp = _this$props4.onMouseUp;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (ripple) {
        _this.debounce(_this.cleanUp, 2000, e);
      }

      if (onMouseUp) {
        onMouseUp(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props5 = _this.props,
          loading = _this$props5.loading,
          loaderNode = _this$props5.loaderNode,
          children = _this$props5.children,
          icon = _this$props5.icon;

      if (loading) {
        return (0, _lib.getRenderProps)(loaderNode, _this.props);
      }

      if (icon && children) {
        // fix margin between icon and children
        return _react["default"].createElement("span", null, children);
      }

      if (children) return _react["default"].createElement("span", null, children);
      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props6 = _this.props,
          ripple = _this$props6.ripple,
          disabled = _this$props6.disabled;

      if (ripple && !disabled) {
        return _react["default"].createElement("span", {
          className: "ripple-children"
        }, _this.renderContent());
      }

      return _this.renderContent();
    });

    _defineProperty(_assertThisInitialized(_this), "renderIcon", function () {
      var _this$props7 = _this.props,
          icon = _this$props7.icon,
          loading = _this$props7.loading;

      if (icon && !loading) {
        if ((0, _lib.isString)(icon)) {
          return _react["default"].createElement(_Icon["default"], {
            name: icon
          });
        }

        return icon;
      }

      return null;
    });

    return _this;
  }

  _createClass(Button, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearDebounce();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          as = _this$props8.as,
          attached = _this$props8.attached,
          basic = _this$props8.basic,
          fluid = _this$props8.fluid,
          className = _this$props8.className,
          children = _this$props8.children,
          icon = _this$props8.icon,
          innerRef = _this$props8.innerRef,
          ripple = _this$props8.ripple,
          borderless = _this$props8.borderless,
          outline = _this$props8.outline,
          disabled = _this$props8.disabled,
          color = _this$props8.color,
          loading = _this$props8.loading,
          loaderNode = _this$props8.loaderNode,
          textAlign = _this$props8.textAlign,
          _float2 = _this$props8["float"],
          upperCase = _this$props8.upperCase,
          capitalize = _this$props8.capitalize,
          rest = _objectWithoutProperties(_this$props8, ["as", "attached", "basic", "fluid", "className", "children", "icon", "innerRef", "ripple", "borderless", "outline", "disabled", "color", "loading", "loaderNode", "textAlign", "float", "upperCase", "capitalize"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var ref = innerRef || this.innerRef;
      var classNames = this.classNames();
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        ref: ref,
        className: classNames,
        disabled: disabled,
        onClick: this.handleOnClick,
        onMouseDown: this.handleOnMouseDown,
        onMouseUp: this.handleOnMouseUp
      }), this.renderIcon(), this.renderChildren(), ripple && !basic && !disabled && _react["default"].createElement("div", {
        className: "ripple-container",
        ref: this.rippleRef
      }));
    }
  }]);

  return Button;
}(_react.PureComponent);

exports["default"] = Button;

_defineProperty(Button, "displayName", 'Button');

_defineProperty(Button, "className", 'MHub-Button');

_defineProperty(Button, "propTypes", {
  as: _common.customPropTypes.as,
  children: _propTypes["default"].node,
  type: _propTypes["default"].string,
  icon: _common.customPropTypes.icon,
  color: _propTypes["default"].oneOf(['blue', 'red', 'white', 'green']),
  className: _propTypes["default"].string,
  attached: _common.customPropTypes.attachedHorizontal,
  onClick: _propTypes["default"].func,
  basic: _propTypes["default"].bool,
  ripple: _propTypes["default"].bool,
  borderless: _propTypes["default"].bool,
  outline: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  fluid: _propTypes["default"].bool,
  innerRef: _common.customPropTypes.ref,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  loading: _propTypes["default"].bool,
  loaderNode: _common.customPropTypes.render,
  textAlign: _common.customPropTypes.textAlign,
  "float": _common.customPropTypes["float"],
  upperCase: _propTypes["default"].bool,
  capitalize: _propTypes["default"].bool
});

_defineProperty(Button, "defaultProps", {
  as: 'button',
  children: null,
  type: 'button',
  icon: null,
  color: null,
  className: null,
  attached: null,
  onClick: null,
  basic: false,
  ripple: false,
  borderless: false,
  outline: false,
  disabled: false,
  fluid: false,
  innerRef: null,
  onMouseDown: null,
  onMouseUp: null,
  loading: false,
  loaderNode: function loaderNode(_ref) {
    var disabled = _ref.disabled,
        color = _ref.color,
        borderless = _ref.borderless,
        outline = _ref.outline,
        basic = _ref.basic;
    return _react["default"].createElement(_Logo["default"], {
      loading: true,
      color: !disabled && color !== 'white' && !(borderless || outline || basic) ? 'white' : color,
      style: {
        width: '2.5em',
        height: '1em'
      }
    });
  },
  textAlign: 'center',
  "float": null,
  upperCase: false,
  capitalize: false
});